import quantitySelector from "./quantity-selector";
import setTransition from "./set-transition";
import teleport from "./teleport";
import cart from "./cart";
import cartDrawer from "./cart-drawer";
import embla from "./embla";
import lenis from "./lenis";
import productRecommendations from "./product-recommendations";
import accordion from "./accordion";
import threeD from "./three-d";
import scrollTo from "./scroll-to";
import * as header from "./header";
import * as animate from "./animate";
// import perspectiveHover from "./perspective-hover";
import announcementBar from "./announcement-bar";
import parallax from "./parallax";
import addToCartFlow from "./add-to-cart-flow";
import * as footer from "./footer";
import scrollAccordion from "./scroll-accordion";
import mentionedIn from "./mentioned-in";

import Alpine from "alpinejs";
import productForm from "./product-form";
import loader from "./loader";
import cartStore from "./cart-store";

Alpine.store("cartStore", cartStore);

Alpine.data("cart", cart);
Alpine.data("cartDrawer", cartDrawer);
Alpine.data("productForm", productForm);
Alpine.data("quantitySelector", quantitySelector);
Alpine.data("loader", loader);

// add all components that only needs to be initialized once
// (typically things related to window or elements outside of <main>)
export const globals = [
  cart,
  lenis,
  header.setActiveHeaderLink,
  header.spinLogo,
  header.headerMobileMenuToggle,
  announcementBar,
];

// add all components that needs to be initialized after every page shift
export const components = [
  embla,
  productRecommendations,
  setTransition,
  teleport,
  accordion,
  threeD,
  scrollTo,
  // perspectiveHover,
  animate.text,
  animate.items,
  animate.fadeIn,
  parallax,
  addToCartFlow,
  footer.getHeightReference,
  footer.moveLogoWhenInView,
  footer.spinLogoOnScroll,
  scrollAccordion,
  mentionedIn,
];
